/* eslint-disable import/no-anonymous-default-export */
import { fetchApi } from 'containers/helpers'

export const resetPassword = ({email}) => fetchApi(`/user/resetPassword/${email}`)

export default {
  resetPassword,
}
